module.exports = __webpack_public_path__ + "img/favicon.9ef498f7.png";